<div class="-mb-3">
  <div class="flex items-baseline justify-between gap-2">
    <rk-page-title
      [title]="'MEDIA.CONTEXT_MENU.ADD_PROGRAM_PLAYLIST' | translate"
    ></rk-page-title>
  </div>
</div>
<div class="form-container flex flex-1">
  <div
    class="subtitle"
    [innerHTML]="'SCHEDULE.PROGRAMS.ADD_PLAYLIST_STEP_1' | translate"
  ></div>
  @if ((playlistsUnfiltered$ | async)?.length) {
    <rk-search-bar
      (inputted)="onChangeSearch($event)"
      [customPlaceholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
    ></rk-search-bar>
    @if ((playlists$ | async)?.length) {
      <div class="playlists-title my-2 px-6 -mx-5 h-9 flex items-center" translate>
        MEDIA.PLAYLISTS.TITLE
      </div>
      <div class="playlist-list flex flex-1 bg-white -mx-5 px-3">
        <cdk-virtual-scroll-viewport
          class="flex-1 w-full"
          itemSize="44"
          minBufferPx="800"
          maxBufferPx="1000"
        >
          <div
            class="playlist-line relative flex items-center gap-2.5 text-black flex-1 py-3 px-2"
            *cdkVirtualFor="
              let playlist of playlists$ | async;
              let i = index;
              templateCacheSize: 60
            "
            (click)="selectPlaylist(playlist)"
          >
            <rk-playlist-icon class="h-5" [playlist]="playlist"></rk-playlist-icon>
            <div class="truncate text-base">{{ playlist.name }}</div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    } @else {
      <div class="search-empty">
        <img src="/assets/search-empty.svg" alt="" />
        <div>
          {{
            'MEDIA.TABLE.SEARCH_EMPTY' | translate: { search: searchSubject.getValue() }
          }}
        </div>
      </div>
    }
  } @else {
    Aucune playlist
  }
</div>
